import cheerio from 'cheerio'

const TITLE_TAGS = ['h2']

export const parseLessonContent = (content, hasExercises) => {
  const $ = cheerio.load(`<body>${content}</body>`)
  const titles = $(TITLE_TAGS.join(', '))
  const children = $('body').children()

  const buildOptions = { hasExercises, $, titles }
  const summary = buildLessonSummary(buildOptions)
  const contents = buildLessonContent(summary, children, buildOptions)

  return {
    summary,
    contents,
  }
}

const joinContentTags = (tags) => {
  return tags.reduce((prev, curr) => {
    return prev + cheerio.html(curr)
  }, '')
}

const buildLessonSummary = (options) => {
  const { $, titles, hasExercises } = options

  return [
    { text: 'Introdução', id: 'intro' },

    ...titles.map((index, title) => {
      return {
        text: $(title).text(),
        id: `content-${index}`,
      }
    }),

    ...(hasExercises ? [{ text: 'Exercícios', id: 'exercises', ignoreForContent: true }] : []),
  ]
}

const buildLessonContent = (summary, children, options) => {
  const { $ } = options
  let remainingChildren = children

  return summary
    .filter(item => !item.ignoreForContent)
    .map((item) => {
      const tags = []

      for (let index = 0; index < remainingChildren.length; index++) {
        const child = remainingChildren[index]

        if (TITLE_TAGS.includes(child.name)) break

        tags.push(child)
      }

      remainingChildren = remainingChildren.slice(tags.length + 1)

      return {
        title: item.text,
        id: item.id,
        content: joinContentTags(tags, $),
      }
    })
}
